import { useState } from 'react';

import { ShipmentDetail } from '@/components/views/shipment/detail';
import { useEmissionsCalculation } from '@/hooks/use-emissions-calculation';
import { ShipmentModel } from '@/lib/models/shipment/types';
import { buildEmissionsSegments, getCargoData } from '@/lib/models/shipment/utils/build-emissions-segments';

export interface ShipmentDetailViewControllerProps {
  shipment: ShipmentModel | null;
  isLoading: boolean;
  error?: string;
  isRefreshing?: boolean;
  onBack: () => void;
  onRequestRefresh: () => void;
  onClickDetails?: (value: ShipmentModel) => void;
}

const ShipmentDetailViewController = ({
  shipment,
  isLoading,
  error,
  isRefreshing,
  onBack,
  onRequestRefresh,
  onClickDetails,
}: ShipmentDetailViewControllerProps) => {
  const [currentTab, setCurrentTab] = useState<string>('milestones');

  const emissionsSegments = buildEmissionsSegments(shipment?.journey?.segments);
  const cargoData = getCargoData(shipment);
  // const cargoData = [shipment?.cargo || { type: CARGO_TYPES.CONTAINER, quantity: 1 }];

  const { data, isLoading: isEmissionsLoading } = useEmissionsCalculation({
    segments: emissionsSegments,
    cargo: cargoData,
    isEnabled: currentTab === 'emissions',
  });

  return (
    <ShipmentDetail
      shipment={shipment}
      isLoading={isLoading}
      isRefreshing={isRefreshing}
      error={error}
      onBack={onBack}
      onRequestRefresh={onRequestRefresh}
      onClickDetails={onClickDetails}
      currentTab={currentTab}
      onTabChange={setCurrentTab}
      emissions={{
        isLoading: isEmissionsLoading,
        emissionsData: data,
        cargo: cargoData,
        updatedAt: shipment?.trackingUpdatedAt || new Date().toISOString(),
        canSeeEmissions: true,
      }}
    />
  );
};

export { ShipmentDetailViewController };
